// extracted by mini-css-extract-plugin
export default {"Logo":"SiHsPartnerModal-module__Logo__xi_aq","Message":"SiHsPartnerModal-module__Message__Jcefs"};